module.exports = __webpack_public_path__ + "files/bd9ce12acdb6c5c87ea2595d200f2334.png";